import { type CSSProperties } from "react";

type SkeletonProps = {
  className?: string;
  /** Inline width override (e.g. "60%", 120). */
  width?: string | number;
  /** Inline height override (e.g. "1rem", 16). */
  height?: string | number;
  /** Pill vs rounded-rect. */
  rounded?: "sm" | "md" | "lg" | "xl" | "full";
  style?: CSSProperties;
};

const roundedClass: Record<NonNullable<SkeletonProps["rounded"]>, string> = {
  sm: "rounded",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  full: "rounded-full",
};

/**
 * Lightweight shimmer placeholder used while async data loads. Pure CSS
 * (`animate-pulse`) so it has no runtime cost and respects reduced-motion via
 * Tailwind's motion-safe behaviour.
 */
export const Skeleton = ({
  className = "",
  width,
  height,
  rounded = "md",
  style,
}: SkeletonProps) => (
  <span
    aria-hidden="true"
    className={`block animate-pulse bg-gray-200/80 ${roundedClass[rounded]} ${className}`}
    style={{ width, height, ...style }}
  />
);

export default Skeleton;
